import {BaseDevice} from "./base.device";
import {HttpClient} from "@angular/common/http";
import {Inject, Injectable} from "@angular/core";
import {BASE_CLIENT, BaseClient} from "../client/base.client";
import {preloaderFinished} from "../auth/preloader";
import {Itoken} from "../auth/itoken";
import {IWindow} from "./model/window";
import {Observable, from, of} from "rxjs";
import {NavigationBar} from "./model/navigationbar";
import {ITitle} from "./model/title";
import {IShare} from "./model/share";
import {UserLocation} from "./model/location";
import {TokenService} from "../token/token.service";
import {UserService} from "../user/user.service";

declare let yz;

@Injectable({
  providedIn: "root"
})
export class IOS extends BaseDevice {
  constructor(
    private tokenService: TokenService,
    private http: HttpClient,
    private user: UserService,
    @Inject(BASE_CLIENT) private baseclient: BaseClient
  ) {
    super();
  }

  /**
   * 手机网页认证
   */
  auth(): Promise<any> {
    if (this.baseclient.ios && this.baseclient.ios.auth === false) {
      return new Promise<any>((resolve, reject) => {
        preloaderFinished();
        resolve(true);
      });
    }
    if (null === this.baseclient.mobileVersion || this.baseclient.mobileVersion === "V6") {
      return new Promise<any>((resolve, reject) => {
        // 设置token
        this.tokenService.set(this.getToken() as any);
        // 发送/user请求
        this.http
          .get(`${this.baseclient.gateway}/auth/user`)
          .subscribe((response: any) => {
            // 设置user
            this.user.set({ ...response.principal, tenantId: response.tenantId });
            // 加载结束
            preloaderFinished();
            resolve(true);
          });
      });
    } else if (null !== this.baseclient.mobileVersion && this.baseclient.mobileVersion === "V5") {
      const userInfo = yz.getUserInfoSync();
      const formData = new FormData();
      const {account, password} = userInfo;
      formData.set("username", account);
      formData.set("password", password);
      formData.set("grant_type", "password");
      formData.set("client_id", "webapp");
      formData.set("scope", "webapp");
      formData.set("client_secret", "123456");
      return new Promise<any>(((resolve, reject) => {
        this.http.post(`${this.baseclient.gateway}/auth/oauth/token`, formData).subscribe(
          (response: any) => {
            let tokenInfo = {};
            tokenInfo['accessToken'] = response.access_token;
            tokenInfo['tokenType'] = response.token_type;
            tokenInfo['refreshToken'] = response.refresh_token;
            tokenInfo['expiresIn'] = response.expires_in;
            tokenInfo['scope'] = response.scope;
            this.tokenService.set(tokenInfo as any)
            this.http.get(`${this.baseclient.gateway}/auth/user`).subscribe(
              (response: any) => {
                // 设置user
                this.user.set({ ...response.principal, tenantId: response.tenantId });
                // 加载结束
                preloaderFinished();
                resolve(true);
              });
          });
      }))
    }
  }

  getToken(): Itoken {
    return yz.getTokenSync();
  }

  openWindow(window: IWindow): void {
    yz.navigationOpenWindow(window);
    if (window.listener) {
      yz.listener.nBack(window.listener);
    }
  }

  scanCode(): Observable<string> {
    return from(
      new Promise<string>((resolve, reject) => {
        yz.scanCode({
          success(data) {
            resolve(data);
          },
          fail(errMsg) {
            reject("error");
          }
        });
      })
    );
  }

  setNavigationBar(navigationBar: NavigationBar): void {
    yz.setNavigationBarRightItems({
      showMenu: navigationBar.showMenu,
      shareFlag: navigationBar.shareFlag,
      items: navigationBar.items,
      onClick: navigationBar.onClick,
      success: navigationBar.success,
      fial: navigationBar.fial,
      complete: navigationBar.complete
    });
  }

  setTitle(ititle: ITitle): void {
    yz.setNavigationBarTitle(ititle);
  }

  share(ishare: IShare): void {
    yz.setWebCanShare(ishare);
  }

  userLocation(): Observable<UserLocation | any> {
    return from(
      new Promise((resolve, reject) => {
        yz.userLocation({
          success(data: any) {
            resolve({
              address: data.address,
              latitude: data.latitude,
              longitude: data.longitude
            } as UserLocation);
          },
          fail(errMsg: any) {
            reject(errMsg);
          }
        });
      })
    );
  }

  validateInWifi(bssids: Array<string>): Observable<boolean | any> {
    return from(
      new Promise((resolve, reject) => {
        yz.userLocationContainAp({
          bssids,
          success(data: boolean) {
            resolve(data);
          },
          fail(errMsg: any) {
            reject(errMsg);
          }
        });
      })
    );
  }

  getWifiMac(): Observable<string | any> {
    return from(
      new Promise((resolve, reject) => {
        yz.getMac({
          success(data: string) {
            resolve(data);
          },
          fail(errorMsg) {
            reject(errorMsg);
          }
        });
      })
    );
  }

  chooseContacts(count: number): Observable<any> {
    return from(
      new Promise((resolve, reject) => {
        yz.chooseContacts({
          count,
          success(data: any) {
            resolve(data);
          },
          fail(errMsg: any) {
            reject(errMsg);
          }
        });
      })
    );
  }

  contactDetails(targetUserId: string): Observable<any> {
    return from(
      new Promise((resolve, reject) => {
        yz.ContactDetails({
          targetUserId,
          success: data => {
            resolve(data);
          },
          fail: errMsg => {
            reject(errMsg);
          }
        });
      })
    );
  }


  uploadImage(count: number, sourceType: any): Observable<any> {
    return from(
      new Promise((resolve, reject) => {
        yz.uploadImage({
          count,
          sourceType,
          success: data => {
            resolve(data);
          },
          fail: errMsg => {
            reject(errMsg);
          }
        });
      })
    );
  }

  openReadWithTimer(url: any, openType: any, title: any, id: any, type: any): Observable<any> {
    return from(
      new Promise((resolve, reject) => {
        yz.openReadWithTimer({
          url,
          openType,
          title,
          id,
          type,
          success: data => {
            resolve(data);
          },
          fail: errMsg => {
            reject(errMsg);
          }
        });
      })
    );
  }


  uploadMovie(limitMinute: number ): Observable<any> {
    return from(
      new Promise((resolve, reject) => {
        yz.uploadMovie({
          limitMinute,
          success: data => {
            resolve(data);
          },
          fail: errMsg => {
            reject(errMsg);
          }
        });
      })
    );
  }

  fileBrowser(url: string, title: string): Observable<any> {
    return from(
      new Promise((resolve, reject) => {
        yz.fileBrowser({
          url,
          title,
          success: data => {
            resolve(data);
          },
          fail: errMsg => {
            reject(errMsg);
          }
        });
      })
    );
  }

  startSearchBeacons(ticket: string, callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
  stopSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
  onSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
}
